import { Redirect, useLocalSearchParams } from 'expo-router'

export default function LegacyFormEntry() {
  const { formToken, entryId } = useLocalSearchParams<{ formToken: string; entryId: string }>()
  return <Redirect href={`/forms/${formToken}/entries?serial_number=${entryId}` as any} />
}
